var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entries && _vm.entries.length > 0)?_c('div',[(_vm.key === 'items/type-counts')?_c('InfoCardSection',{attrs:{"section":_vm.contentCardSection}}):_c('ContentCardSection',{attrs:{"section":_vm.contentCardSection}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }